import { inject, Injectable } from "@angular/core";
import { JournalsService } from "../journals.service";
import { Action, State, StateContext, Store } from "@ngxs/store";
import { JournalsStateModel } from "./journals.model";
import { catchError, tap } from "rxjs";
import { SetShowLoader, ShowToastrAlert } from "app/modules/shared-state/shared.actions";
import { OnSetSharedGridRowData } from "app/modules/shared/ag-grid/shared-grid-state/shared-grid.actions";
import { SharedGridState } from "app/modules/shared/ag-grid/shared-grid-state/shared-grid.state";
import { GetJournals } from "./journals.actions";

@State<JournalsStateModel>({
  name: 'journals',
})

@Injectable()
export class JournalsState {
  private _store = inject(Store);
  private _salesInvoicesService = inject(JournalsService);


  @Action(GetJournals)
  getSalesInvoices(ctx: StateContext<JournalsStateModel>) {
    ctx.dispatch(new SetShowLoader(true));
    return this._salesInvoicesService.getAllJournals().pipe(
      catchError((error) => {
        ctx.dispatch(new SetShowLoader(false));
        ctx.dispatch(new ShowToastrAlert({
          showToast: true,
          toastrType: 'error',
          messageTitle: 'Error',
          messageBody: error.error.message.message,
          position: 'toast-top-center'
        }));
        throw error;
      }),
      tap((data: any) => {
        ctx.dispatch(new OnSetSharedGridRowData({
          reload: true,
          payload: data,
          gridUUID: this._store.selectSnapshot(SharedGridState.getGridReferenceUUIDs).firstGridUUID
        }));
        ctx.dispatch(new SetShowLoader(false));
      })
    );
  }

}